import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CiomsData } from '@/app/reports/cioms-demo/handleFetchCase';

interface CiomsDataState {
  collectedData: Partial<CiomsData>;
  isCollecting: boolean;
  lastUpdated: string | null;
}

const initialState: CiomsDataState = {
  collectedData: {},
  isCollecting: false,
  lastUpdated: null,
};

export const ciomsDataSlice = createSlice({
  name: 'ciomsData',
  initialState,
  reducers: {
    startDataCollection: (state) => {
      state.isCollecting = true;
      state.lastUpdated = new Date().toISOString();
    },
    stopDataCollection: (state) => {
      state.isCollecting = false;
    },
    updateCollectedData: (state, action: PayloadAction<Partial<CiomsData>>) => {
      state.collectedData = { ...state.collectedData, ...action.payload };
      state.lastUpdated = new Date().toISOString();
    },
    clearCollectedData: (state) => {
      state.collectedData = {};
      state.lastUpdated = null;
    },
    setSpecificData: (state, action: PayloadAction<{ key: keyof CiomsData; value: any }>) => {
      const { key, value } = action.payload;
      (state.collectedData as any)[key] = value;
      state.lastUpdated = new Date().toISOString();
    },
  },
});

export const {
  startDataCollection,
  stopDataCollection,
  updateCollectedData,
  clearCollectedData,
  setSpecificData,
} = ciomsDataSlice.actions;

export default ciomsDataSlice.reducer; 